import React from 'react';
import { MetaList } from 'modules';
import { RawContent } from 'elements/util';
import {
  Paragraph,
  Anchor
} from 'elements';
import {
  SiteContainer,
  Flex,
  FlexItem,
  Wrapper,
  Main,
} from 'core/layout';
import tulkojumi from 'utils/tulkojumi';
import { getParsedDataFromPages } from 'utils/deepProps';
import {
  StyledFlexItem,
  StyledHeading,
  StyledPartija,
  StyledParagraph,
  StyledImageDiv,
} from './styled';

class Deputats extends React.PureComponent {
  render() {
    const { deputats, teksti, type } = this.props;

    let acf
    if(deputats.acf){
      acf = getParsedDataFromPages(deputats, 'acf')
    }
    // console.log(acf)
    // console.log(deputats)
    // console.log(tulkojumi(teksti, 'publicets'))

    return type==='domes-vadiba'?
            (<StyledFlexItem basis={1} >

              <Flex>
              <StyledFlexItem basis={5/12} >
              <StyledImageDiv>
              { deputats.images && deputats.images[0]
                && deputats.images[0].thumb
                && deputats.images[0].thumb[1]
                ? <img src={deputats.images[0].thumb[1].url} width={deputats.images[0].thumb[1].width} height={deputats.images[0].thumb[1].height} title={ deputats.title } alt={ deputats.title } />
                :null }
              </StyledImageDiv>
              <Anchor href={deputats.images[0].src} target='_blank'>{tulkojumi(teksti, 'foto_medijiem')}</Anchor>
              </StyledFlexItem>

              <StyledFlexItem basis={6/12} >
                <StyledHeading level='3'>{ deputats.title }</StyledHeading>
                <RawContent content={deputats.content} />
                <p>
                  { acf&&acf.cv?<Anchor href={acf.cv} target='_blank'>CV</Anchor>:null }
                </p>
              </StyledFlexItem>
              </Flex>

            </StyledFlexItem>)


            :

            (<StyledFlexItem basis={1/3} >

              { deputats.images && deputats.images[0]
                && deputats.images[0].thumb
                && deputats.images[0].thumb[0]
                ? <div><img src={deputats.images[0].thumb[0].url} width={deputats.images[0].thumb[0].width} height={deputats.images[0].thumb[0].height} title={ deputats.title } alt={ deputats.title } /></div>
                :null }
              { deputats.terms&&deputats.terms.domes_partija&&deputats.terms.domes_partija[0]?<StyledPartija>{tulkojumi(teksti, 'partija')}: {deputats.terms.domes_partija[0].name}</StyledPartija>:null }
              <StyledHeading level='5'>{ deputats.title }</StyledHeading>
              { acf&&acf.cv?<Anchor href={acf.cv} target='_blank'>CV</Anchor>:null }
              { acf&&acf.iedzivotaju_pienemsana?<Paragraph>{acf.iedzivotaju_pienemsana}</Paragraph>:null }

            </StyledFlexItem>)
  }
}

export default Deputats;



// WEBPACK FOOTER //
// ./src/pages/Deputati/components/Deputats/Deputats.jsx